import {
    NEW_PAYMENT_DATA_RECEIVED,
    APPROVE_DISCOUNT_START,
    APPROVE_DISCOUNT_ERROR,
    SUGGEST_DISCOUNT_START,
    SUGGEST_DISCOUNT_ERROR,
} from './paymentActionTypes.js';

const initialState = {
    error: false,
    loading: false,
    data: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case NEW_PAYMENT_DATA_RECEIVED:
            return {
                data: {
                    ...state.data,
                    ...action.payload.data,
                },
                loading: false,
                error: false,
            };
        case APPROVE_DISCOUNT_START:
        case SUGGEST_DISCOUNT_START:
            return {
                ...state,
                loading: true,
                error: false,
            };
        case APPROVE_DISCOUNT_ERROR:
        case SUGGEST_DISCOUNT_ERROR:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./safeTrade/seller/payment/paymentReducer.js